import { isCanlan } from './customer-name'

export const getCustomerSupportUrl = () => {
  return isCanlan
    ? 'https://www.canlansports.com/customersupport/'
    : 'https://support.sportninja.com/'
}
